export type DashboardInsightsPeriod = 'Month to Date' | 'Quarter to Date' | 'Year to Date' | 'Last 30 Days' | 'Last 12 Months';

export class DashboardInsightMetric {
	public currentValue?: number;
	public previousValue?: number;

	constructor(dashboardInsightMetric?: DashboardInsightMetric) {
		Object.assign(this, dashboardInsightMetric);
	}
}

export class DashboardInsightsRenewedMetric {
	public currentRenewedContracts?: number;
	public currentAvailableRenewalContracts?: number;
	public previousRenewedContracts?: number;
	public previousAvailableRenewalContracts?: number;

	constructor(dashboardInsightsRenewedMetric?: DashboardInsightsRenewedMetric) {
		Object.assign(this, dashboardInsightsRenewedMetric);
	}

	get currentValue(): number {
		return this.currentAvailableRenewalContracts ? (this.currentRenewedContracts || 0) / this.currentAvailableRenewalContracts : 0;
	}

	get previousValue(): number {
		return this.previousAvailableRenewalContracts ? (this.previousRenewedContracts || 0) / this.previousAvailableRenewalContracts : 0;
	}
}

export class DashboardInsightsSummary {
	public totalCommissionPaidLifetime?: number;
	public upcomingMonthForecastedPayable?: number;
	public futureMonthsForecastedPayable?: number;
	public upcomingMonthName?: string;

	constructor(dashboardInsightsSummary?: DashboardInsightsSummary) {
		Object.assign(this, dashboardInsightsSummary);
	}
}

export class DashboardInsightsDetails {
	public commission?: DashboardInsightMetric;
	public contractsSold?: DashboardInsightMetric;
	public confirmedElectricityVolume?: DashboardInsightMetric;
	public confirmedGasVolume?: DashboardInsightMetric;
	public contractsRenewed?: DashboardInsightsRenewedMetric;

	constructor(dashboardInsightsDetails?: DashboardInsightsDetails) {
		Object.assign(this, dashboardInsightsDetails);

		this.commission = new DashboardInsightMetric(this.commission);
		this.contractsSold = new DashboardInsightMetric(this.contractsSold);
		this.confirmedElectricityVolume = new DashboardInsightMetric(this.confirmedElectricityVolume);
		this.confirmedGasVolume = new DashboardInsightMetric(this.confirmedGasVolume);
		this.contractsRenewed = new DashboardInsightsRenewedMetric(this.contractsRenewed);
	}
}

export class DashboardInsights extends DashboardInsightsSummary {
	public commission?: DashboardInsightMetric;
	public contractsSold?: DashboardInsightMetric;
	public confirmedElectricityVolume?: DashboardInsightMetric;
	public confirmedGasVolume?: DashboardInsightMetric;
	public contractsRenewed?: DashboardInsightsRenewedMetric;

	constructor(dashboardInsights?: DashboardInsights) {
		super(dashboardInsights);

		this.commission = new DashboardInsightMetric(dashboardInsights?.commission);
		this.contractsSold = new DashboardInsightMetric(dashboardInsights?.contractsSold);
		this.confirmedElectricityVolume = new DashboardInsightMetric(dashboardInsights?.confirmedElectricityVolume);
		this.confirmedGasVolume = new DashboardInsightMetric(dashboardInsights?.confirmedGasVolume);
		this.contractsRenewed = new DashboardInsightsRenewedMetric(dashboardInsights?.contractsRenewed);
	}
}
